export default (sku: string, language: string) => {
    const encoded = encodeURIComponent(sku);

    if (typeof (language) !== "undefined" && language !== null && language !== "da") {
        return `/${language}/product/${encoded}`;
    }

    return `/product/${encoded}`;
}